// Navigation
const NAV = [
  {
    title: "UCLA Centennial",
    items: [
      { internal: true, text: "Vision", url: "/vision" },
      { internal: true, text: "Impact", url: "/impact" },
      // { internal: true, text: "Events", url: "/events" },
      { internal: true, text: "Initiatives", url: "/initiatives" },
      { internal: true, text: "News", url: "/news" },
      { internal: true, text: "Timeline", url: "/timeline" },
      { internal: false, text: "Store", url: "https://shop.uclastore.com/c-988-centennial-collection.aspx" }
    ]
  },
  {
    title: "Information",
    items: [
      {
        internal: false,
        text: "Careers",
        url: "http://www.ucla.edu/about/careers"
      },
      {
        internal: false,
        text: "Directory",
        url: "http://www.directory.ucla.edu/"
      },
      { internal: false, text: "Contact", url: "http://www.ucla.edu/contact" },
      {
        internal: false,
        text: "Academic Calendar",
        url: "https://www.registrar.ucla.edu/Calendars/Overview"
      },
      {
        internal: false,
        text: "Maps, Directions",
        url: "http://www.ucla.edu/maps-directions-parking/"
      },
      {
        internal: false,
        text: "Parking & Transportation",
        url: "https://transportation.ucla.edu/campus-parking"
      },
      { internal: false, text: "Emergency", url: "https://www.bso.ucla.edu/" }
    ]
  },
  {
    title: "Campus Values",
    items: [
      {
        internal: false,
        text: "Equity, Diversity & Inclusion",
        url: "https://equity.ucla.edu/"
      },
      {
        internal: false,
        text: "Environment & Sustainability",
        url: "http://www.ucla.edu/environment-and-sustainability"
      },
      {
        internal: false,
        text: "True Bruin Statement",
        url: "https://truebruin.ucla.edu/"
      },
      {
        internal: false,
        text: "Volunteerism",
        url: "https://volunteer.ucla.edu/ "
      },
      {
        internal: false,
        text: "Give to UCLA",
        url: "https://giving.ucla.edu/Campaign/Donate.aspx"
      }
    ]
  },
  {
    title: "Event Venues",
    items: [
      {
        internal: false,
        text: "Luskin Conference Center",
        url: "https://luskinconferencecenter.ucla.edu/"
      },
      {
        internal: false,
        text: "Event Planning",
        url: "https://events.ucla.edu/"
      },
      {
        internal: false,
        text: "Film Production",
        url: "http://uclaevents.com/filming-and-photography/"
      }
    ]
  }
];

// Legal
const _year = new Date().getFullYear();
const LEGAL = `©${_year}&nbsp;Regents&nbsp;of&nbsp;the&nbsp;University&nbsp;of&nbsp;California <a href="http://www.ucla.edu/terms-of-use" target="_blank">Terms&nbsp;of&nbsp;Use</a>&nbsp;<a href="http://www.ucla.edu/accessibility" target="_blank">Accessibility</a>`;

// Contact
const CONTACT = `General inquiries: <a href="mailto:centennial@ucla.edu" target="_blank">centennial@ucla.edu</a>`;

// Social
const SOCIAL = [
  {
    icon: "/static/images/instagram.svg",
    url: "https://www.instagram.com/ucla/",
    width: 23,
    height: 23,
    title: "Instagram"
  },
  {
    icon: "/static/images/facebook.svg",
    url: "https://facebook.com/UCLA",
    width: 23,
    height: 23,
    title: "Facebook"
  },
  {
    icon: "/static/images/twitter.svg",
    url: "https://twitter.com/ucla",
    width: 28,
    height: 23,
    title: "Twitter"
  },
  {
    icon: "/static/images/youtube.svg",
    url: "https://youtube.com/user/UCLA",
    width: 28,
    height: 20,
    title: "YouTube"
  }
];

export { NAV, LEGAL, CONTACT, SOCIAL };
